<template>
  <div class="user">
    <div class="photo">
      <md-icon>person</md-icon>
    </div>
    <div class="user-info">
      <router-link :to="{ name: 'Profil' }">
        <span>
          {{ name }}
        </span>
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userData']),
    name() {
      return `${this.userData.name} ${this.userData.surname}`
    },
  },
}
</script>
<style>
.photo {
  display: flex;
  align-items: center;
  justify-content: center;
}
.collapsed {
  transition: opacity 1s;
}
</style>
